// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '영일제약',
  targetSheetName: '2026년 6월 CSO 요율표',
  headerRowIndex: 6,
  headerRowCount: 1,
  dataStartRowIndex: 7,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제 품 명',
    price: '보험약가(원)',
    commissionRate: '요 율',
    commissionNote: '비 고',
  },
  requiredHeaders: [
    'No.',
    '분류번호',
    '약효 구분',
    '제 품 명',
    '성 분',
    '함 량',
    '보험약가(원)',
    '보험코드',
    '요 율',
    '비 고',
  ],
});
